export default "__VITE_ASSET__Bxz_Zqx2__"